import { toast } from 'react-toastify';
import ApiBasicErrorResponse from '../shared/interfaces/api-basic-error-response.interface';
import ApiErrorResponse from '../shared/interfaces/api-error-response.interface';
import ApiValidateErrorResponse from '../shared/interfaces/api-validate-error-response.interface';

function extractErrors(nodes: any) {
    const errors: any = [];

    function traverse(node: any) {
        if (node.constraints) {
            Object.values(node.constraints).forEach(message => {
                errors.push(message);
            });
        }

        if (node.children && node.children.length > 0) {
            node.children.forEach( (child: any) => traverse(child));
        }
    }

    nodes.forEach((node: any) => traverse(node));

    return errors;
}


function isApiErrorResponse(data: any): data is ApiErrorResponse {
    return (
        typeof data === 'object' &&
        'timestamp' in data &&
        'statusCode' in data &&
        'error' in data &&
        'message' in data &&
        'path' in data
    );
}

function isApiValidateErrorResponse(
    data: any,
): data is ApiValidateErrorResponse {
    return (
        'errors' in data &&
        data?.errors?.length > 0 &&
        'property' in data?.errors[0] &&
        'value' in data?.errors[0] &&
        'constraints' in data.errors[0]
    );
}

function isApiBasicErrorResponse(data: any): data is ApiBasicErrorResponse {
    return (
        typeof data === 'object' && 'statusCode' in data && 'message' in data
    );
}

function getResponseErrorMessage(
    error: any,
    defaultMessage: string,
): string | string[] {
    if (isApiValidateErrorResponse(error)) {
        return error?.errors.map((e) =>
            JSON.stringify(Object.values(e.constraints)[0]),
        );
    }

    if (isApiErrorResponse(error)) {
        if (typeof error.message === 'string') {
            return error.message;
        }

        if (Array.isArray(error.message)) {
            return error.message;
        }

        return defaultMessage;
    }

    if (isApiBasicErrorResponse(error)) {
        return error.message;
    }
    
    if (error?.errors){
        const errors: string[] = extractErrors(error.errors);
        if (errors.length > 0)
            return errors;
    }

    return defaultMessage;
}

export default function handleResponseError(
    error: unknown,
    defaultMessage: string,
) {
    const errorMessage = getResponseErrorMessage(error, defaultMessage);

    if (Array.isArray(errorMessage)) {
        const tenSeconds = 10000;

        errorMessage.forEach((message, messagesDisplayed) =>
            toast.error(message, {
                autoClose: (messagesDisplayed + 1) * tenSeconds,
            }),
        );

        return;
    }

    toast.error(errorMessage);
}
